<template>
    <div>
        <div class="container">
            <loader item="reserva" estilo="margin-top:200px !important" v-if="loadingReserva" />

            <DynamicLoader
                estilo="margin-top:200px !important"
                :mensaje="mensaje"
                v-if="mensaje.status"
            />

            <Errors :data="errors" :language="$i18n.locale" v-if="errors.status" />

            <div
                v-if="reservaStatus"
                class="row meios-pago shadow justify-content-center"
                style="margin-top:50px !important"
            >
                <div class="row col-12 mt-5">
                    
                    <div class="col-12 titulo">{{$t('payment.title')}}</div>
                    <div class="col-12 text-center font-weight-normal py-3">({{$t('payment.tax')}})</div>

                    <!-- Name -->
                    <div class="col-6 label">{{$t('payment.name')}}</div>
                    <div class="col-6 data">{{userReservation.nombre}}</div>

                    <!-- Check-in -->
                    <div class="col-6 label">CheckIn:</div>
                    <div class="col-6 data">{{ reservation.fecha_inicio }}</div>

                    <!-- Check-out -->
                    <div class="col-6 label">CheckOut:</div>
                    <div class="col-6 data">{{ reservation.fecha_termino }}</div>
                    
                    <!-- ── Desglose: por la plataforma se abona únicamente el
                         primer mes. La comisión se le descuenta al anfitrión,
                         no se le suma al huésped. ── -->
                    <template v-if="hfCommissionEnabled">

                        <!-- Estadía total -->
                        <div class="col-6 label">{{$t('payment.stay-total')}}</div>
                        <div class="col-6 data">{{ stayTotal | convertAndFormatPrice }}</div>

                        <!-- Primer mes: lo único que cobra House & Flats -->
                        <div class="col-6 label">{{$t('payment.first-month')}}</div>
                        <div class="col-6 data">{{ firstMonth | convertAndFormatPrice }}</div>

                        <!-- Resto de los meses: directo al anfitrión -->
                        <div v-if="remainingToHost.amount > 0" class="col-6 label">{{$t('payment.remaining-to-host')}}</div>
                        <div v-if="remainingToHost.amount > 0" class="col-6 data">{{ remainingToHost | convertAndFormatPrice }}</div>

                        <!-- Monto que se abona ahora a House & Flats -->
                        <div class="col-6 label my-5">{{$t('payment.amount-to-pay')}}</div>
                        <div class="col-6 data my-5 font-weight-bold">{{ amountToPay | convertAndFormatPrice }}</div>

                        <div class="col-12 text-center pb-4 payment-commission-note">
                            {{$t('payment.commission-note', { rate: commissionRate })}}
                        </div>

                    </template>

                    <!-- ── Modelo anterior (el anfitrión que tenga asignado el
                         modelo `viejo`): estadía / garantía + cargo por
                         servicio, como siempre. Lo decide el backend en
                         `prices.hf_commission_enabled`, mirando al dueño del
                         alojamiento. ── -->
                    <template v-else>

                        <!-- Stay -->
                        <div v-if="rentalWarranty.amount == 0" class="col-6 label">{{$t('payment.stay')}}</div>
                        <div v-if="rentalWarranty.amount == 0" class="col-6 data">{{ rentalPrice | convertAndFormatPrice }}</div>

                        <!-- Warranty. Ojo con la clave: `payment.warranty` hoy
                             dice "Primer mes"; la garantía es `warranty-deposit`. -->
                        <div v-if="rentalWarranty.amount > 0" class="col-6 label">{{$t('payment.warranty-deposit')}}</div>
                        <div v-if="rentalWarranty.amount > 0" class="col-6 data">{{ rentalWarranty | convertAndFormatPrice }}</div>

                        <!-- Service -->
                        <div class="col-6 label">{{$t('payment.service')}}</div>
                        <div class="col-6 data">{{ rentalCommission | convertAndFormatPrice }}</div>

                        <!-- Total -->
                        <div class="col-6 label my-5">{{$t('payment.total')}}</div>
                        <div class="col-6 data my-5 font-weight-bold">{{ totalPrice | convertAndFormatPrice }}</div>

                    </template>

                </div>

                <div class="col-12">
                    
                    <div class="row justify-content-center p-3">
                        
                        <!-- Mercadopago -->
                        <div class="col-12 col-md-2 col-lg-2 p-3 text-center">
                            <a id="MP" class="btn btn-pago" :href="mercadoPago.mercadopago_url">
                                <img src="@/assets/pagos/mercado-pago.png" alt />
                            </a>
                            <label class="payment-gateway-name" for="MP">Mercado Pago {{$t('payment.only')}} $CLP</label>
                            <div class="payment-gateway-charge">(+ {{ configurations.gatewaysCommissions.mercadopago }} %)</div>
                        </div>

                        <!-- Paypal -->
                        <div class="col-12 col-md-2 col-lg-2 p-3 text-center">
                            <a id="PP" :href="payPal.paypal_url" class="btn btn-pago">
                                <img src="@/assets/pagos/paypal.png" alt />
                            </a>
                            <label class="payment-gateway-name" for="PP">PayPal</label>
                            <div class="payment-gateway-charge">(+ {{ configurations.gatewaysCommissions.paypal }} %)</div>
                        </div>
                        
                        <!-- Transfer -->
                        <div class="col-12 col-md-2 col-lg-2 p-3 mb-5 text-center">
                            <button id="TR" class="btn btn-pago btn-fa" style="margin-bottom: 0px" @click="submitTransfer">
                                <i class="fas fa-university" /> <br>
                            </button>
                            <label class="payment-gateway-name" for="TR">{{$t('payment.transfer')}}</label>
                            <div class="payment-gateway-charge">(+ {{ configurations.gatewaysCommissions.bankTransfer }} %)</div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from "@/components/Loader/Loader";
import DynamicLoader from "@/components/Loader/DynamicLoader";
import Errors from "@/components/Payment/Errors";
import { mapActions, mapState } from "vuex";
import configurations from '@/new-constants/configurations';

export default {
    components: {
        Loader,
        Errors,
        DynamicLoader
    },
    data() {
        return {
            loadingReserva: true,
            loadUrlMP: false,
            loadUrlPP: false,
            loadUrlWP: false,
            loadUrlWPCL: false,
            reservaStatus: false,
            mensaje: {
                es:
                    "Por favor espere mientras completamos el proceso de pago...",
                en: "Please wait while we complete the payment process...",
                status: false
            },
            errors: {
                status: false,
                iconClass: "svg-danger danger",
                class: "danger",
                icon: "exclamation-triangle",
                text: {
                    titulo: {
                        es: "Atencion",
                        en: "Atention"
                    },
                    message: {
                        es: "Mesaje de Prueba",
                        en: "Test Message"
                    }
                }
            }
        };
    },
    methods: {
        ...mapActions([
            "getUrlMP",
            "getUrlPP",
            "getReservation",
            "paymentByTransfer",
        ]),
        loadUrlPagos() {

            let data = {
                idreserva: this.$route.params.id,
                token: this.$route.params.token
            };

            if (process.env.NODE_ENV === 'production') {

                this.getUrlMP(data).then(response => {
                    this.loadUrlMP = true;
                    if (this.loadUrlPP) {
                        this.loadingReserva = false;
                        this.reservaStatus = true;
                    }
                });

                this.getUrlPP(data).then(response => {
                    this.loadUrlPP = true;
                    if (this.loadUrlMP) {
                        this.loadingReserva = false;
                        this.reservaStatus = true;
                    }
                });
                
            } else {
                this.loadingReserva = false;
                this.reservaStatus = true;
            }
        
        },
        submitTransfer() {
            let data = {
                id: this.$route.params.id,
                token: this.$route.params.token
            };

            this.mensaje.status = true;
            this.reservaStatus = false;
            let payment = this.paymentByTransfer(data).then(value => {
                if (value === undefined) {
                    this.mensaje.status = false;

                    this.errors = {
                        status: true,
                        iconClass: "svg-danger suceso",
                        class: "suceso",
                        icon: "fas fa-check-circle",
                        text: {
                            titulo: {
                                es: "Felicitaciones",
                                en: "Congratulations"
                            },
                            message: {
                                es:
                                    "Se ha enviado un correo electrónico con la información para la transferencia. Ahora dispones de 24 horas para poder realizar el depósito y notificarnos del pago para que la reserva quede confirmada. De lo contrario, esta será eliminada automáticamente del sistema.",
                                en:
                                    "An email has been sent with the information for the transfer. Now you have 24 hours to make the deposit and notify us of the payment so that the reservation is confirmed. Otherwise, it will be automatically removed from the system."
                            }
                        }
                    };
                }
            });
        },
        loadReserva() {
            let data = {
                idreserva: this.$route.params.id,
                token: this.$route.params.token
            };

            this.getReservation(data)
                .then(() => {
                    this.loadUrlPagos();
                })
                .catch(error => {
                    this.loadingReserva = false;
                    this.errors.status = true;
                    switch (error.response.data.code) {
                        case "E01":
                            this.errors.text.message.es =
                                "No se encontró la reserva solicitada.";
                            this.errors.text.message.en =
                                "The requested reservation was not found.";
                            break;
                        case "E02":
                            this.errors.text.message.es =
                                "Esta reserva tardó más de 24 horas en pagarse y fue cancelada por el sistema.";
                            this.errors.text.message.en =
                                "This reservation took over 24 hours to pay and was canceled by the system.";
                            break;
                        case "E03":
                            this.errors.text.message.es =
                                "Lo sentimos, esta reserva ha sido cancelada por el propietario del alojamiento.";
                            this.errors.text.message.en =
                                "Sorry, this reservation has been canceled by the owner of the accommodation.";
                            break;
                        case "E04":
                            this.errors.text.message.es =
                                "Lo sentimos, esta reserva no figura como aceptada en nuestro sistema. Revise el estado de su reserva en el dashboard.";
                            this.errors.text.message.en =
                                "Sorry, this reservation is not listed as accepted in our system. Review the status of your reservation in the dashboard.";
                            break;
                        case "E05":
                            this.errors.text.message.es =
                                "El token para esta solicitud no es válido. Acceda a esta página solo por la dirección enviada a su correo electrónico.";
                            this.errors.text.message.en =
                                "The token for this request is not valid. Please access this page only by the address sent to your email.";
                            break;
                        case "E06":
                            this.errors.text.message.es =
                                "Esta reserva ya está pagada en nuestro sistema.";
                            this.errors.text.message.en =
                                "This reservation is already paid in our system.";
                            break;
                        default:
                            this.errors.text.message.es = "";
                            this.errors.text.message.en = "";
                    }
                });
        }
    },
    computed: {
        
        ...mapState([
            "reservation",
            "webPay",
            "webPayCL",
            "payPal",
            "mercadoPago",
            "hyfPago",
            "userReservation",
            "user"
        ]),

        configurations() {
            return configurations;
        },
        
        // Desglose calculado por el backend (ver ReservationController@getById).
        prices() {
            return this.reservation.prices || {};
        },

        /**
         * ¿Va el detalle de hoy (primer mes) o el del modelo anterior (estadía
         * y garantía)? Lo define el backend mirando al dueño del alojamiento,
         * no a quien está pagando. Si el dato no viene —una reserva vieja en
         * caché, por ejemplo— se asume el modelo de hoy.
         */
        hfCommissionEnabled() {
            return this.prices.hf_commission_enabled !== false;
        },

        // ── Modelo anterior ──
        // Estadía y garantía salen de la reserva, que es donde quedaron
        // guardadas al crearla.
        rentalPrice() {
            return { 'amount': Number(this.reservation.costo) || 0, 'currency': this.reservation.moneda }
        },

        rentalWarranty() {
            return { 'amount': Number(this.reservation.garantia) || 0, 'currency': this.reservation.moneda }
        },

        rentalCommission() {
            return { 'amount': Number(this.reservation.comision) || 0, 'currency': this.reservation.moneda }
        },

        // Con garantía se cobra la garantía; sin ella (estadías de menos de 30
        // días) se cobra la estadía. En los dos casos se suma el cargo por
        // servicio.
        totalPrice() {
            let total = Number(this.rentalCommission.amount);

            if (Number(this.rentalWarranty.amount) > 0) {
                total = total + Number(this.rentalWarranty.amount);
            } else {
                total = total + Number(this.rentalPrice.amount);
            }

            return { 'amount': total, 'currency': this.reservation.moneda }
        },

        stayTotal() {
            return { 'amount': Number(this.prices.stay_total) || Number(this.reservation.costo) || 0, 'currency': this.reservation.moneda }
        },

        // Primer mes de arriendo: es lo único que cobra House & Flats.
        firstMonth() {
            return { 'amount': Number(this.prices.first_month) || 0, 'currency': this.reservation.moneda }
        },

        // Meses restantes: se los paga directamente al anfitrión.
        remainingToHost() {
            return { 'amount': Number(this.prices.remaining_to_host) || 0, 'currency': this.reservation.moneda }
        },

        // Monto que se abona ahora por la plataforma.
        amountToPay() {
            return { 'amount': Number(this.prices.amount_to_pay) || 0, 'currency': this.reservation.moneda }
        },

        commissionRate() {
            return Number(this.prices.commission_rate) || 4;
        },

    },
    created() {
        this.loadReserva();
    }
};
</script>

<style scoped lang="scss">

.payment-gateway-name {
    font-size: 1.1rem;
    font-weight: normal;
    margin: 0;
    padding-bottom: 5px !important;
}
.payment-gateway-charge {
    font-size: 0.9rem;
}

.payment-commission-note {
    font-size: 0.9rem;
    font-weight: normal;
    line-height: 1.4;
}

.meios-pago {
    background: #ffffff;
    font: Bold 14px/14px Lato;
    color: #666;
}

.meios-pago label {
    padding: 10px 5px;
    color: $hf-sec-pine;
    line-height: 20px;
}

.btn-pago {
    background-image: linear-gradient(to top, #f3f3f3, #fff);
    border: #f5f5f5 2px solid;
    color: $hf-sec-pine;
    width: 100%;
    height: 100px;
    margin-top: 0;

    &:hover {
        background-image: linear-gradient(to top, #f3f3f3, #fff);
        border: #f5f5f5 2px solid;
        color: $hf-sec-pine;
        width: 100%;
        height: 100px;
        margin-top: 0;
    }

    img {
        max-width: 100%;        
    }
}



a img {
    margin-top: 25px;
}

.btn-pago svg {
    max-width: 100%;
}

.btn-fa svg {
    font-size: 25px;
}

.titulo {
    font-size: 20px;
    text-align: center;
}

.label {
    text-align: right;
    margin-top: 20px;
}

.data {
    margin-top: 20px;
    font-weight: normal;
    text-align: left;
}
</style>